// @ts-nocheck
export const routes = {
    DEFAULT: '/',
    START: '/start',
    TABLE: '/table',
};
